import axios from "axios";
import { handleAxiosError } from "../../../service/error.handler.service";
import { IP_ADDRESS } from "../../../config";
import { store } from "../../../store/store";

export async function getImpersonateService({ company_name, profile_name }) {
  try {
    const impersonator = getOriginalUserInfo();
    const response = await axios.post(
      `${IP_ADDRESS}/profile/impersonateCookie`,
      {
        company_name,
        profile_name,
        impersonator_profile_name: impersonator.profile_name,
        impersonator_company_name: impersonator.company_name,
      }
    );

    return response.data;
  } catch (err) {
    handleAxiosError(err);
  }
}

function getOriginalUserInfo() {
  const state = store.getState();
  return state?.userInfo;
}
